import { grey } from "@mui/material/colors";
import { createTheme } from "@mui/material";
import { mergeDeep } from "gatsby-frontend";

function getTheme(config) {
	const defaultConfig = {
		breakpoints: {
			keys: ["xxs", "xs", "sm", "md", "lg", "xl", "xxl"],
			values: {
				xxs: 0,
				xs: 600,
				sm: 900,
				md: 1270,
				lg: 1420,
				xl: 1536,
				xxl: 1840,
			},
			unit: "px",
		},
		palette: {
			type: "light",
			grey: {
				...grey,
				lighter: grey["100"],
				light: grey["200"],
				main: grey["200"],
				dark: grey["300"],
				darker: grey["400"],
			},
			primary: {
				main: "#1e6da7",
				light: "#4b8ab8",
				dark: "#154c74",
				contrastText: "#fff",
			},
			secondary: {
				main: "#f2838d",
				light: "#f49ba3",
				dark: "#a95b62",
				contrastText: "#fff",
			},
			appBar: {
				private: {
					main: "#1e6da7",
					light: "#4b8ab8",
					dark: "#154c74",
					contrastText: "#fff",
				},
				public: {
					main: "#f5f5f5",
					light: "#fafafa",
					dark: "#eeeeee",
					contrastText: "#424242",
				},
			},
			titleBar: {
				private: {
					main: "#1e6da7",
					light: "#4b8ab8",
					dark: "#154c74",
					contrastText: "#fff",
				},
				public: {
					main: "#1e6da7",
					light: "#4b8ab8",
					dark: "#1e6da7",
					contrastText: "#fff",
				},
			},
			body: {
				main: "#eeeeee",
				light: "#f5f5f5",
				lighter: "#ffffff",
				dark: "#e0e0e0",
				contrastText: "#212121",
			},
			footer: {
				main: "#424242",
				light: "#616161",
				dark: "#212121",
				contrastText: "#fafafa",
			},
			link: {
				main: "#1e6da7",
				light: "#4b8ab8",
				dark: "#154c74",
			},
		},
		shape: {
			borderRadius: 3,
		},
		typography: {
			fontWeight: 400,
			fontWeightBold: 600,
			fontSizeLg: 18,
			fontSizeSm: 14,
			fontSizeXs: 12,
			fontFamily: [
				"Poppins",
				"-apple-system",
				"BlinkMacSystemFont",
				'"Segoe UI"',
				'"Helvetica Neue"',
				"Arial",
				"sans-serif",
				'"Apple Color Emoji"',
				'"Segoe UI Emoji"',
				'"Segoe UI Symbol"',
			].join(","),
			h1: {
				fontWeight: 600,
				lineHeight: 1.167,
				letterSpacing: "-0.01562em",
				fontSize: "2.6rem",
			},
			h2: {
				fontWeight: 600,
				lineHeight: 1.167,
				letterSpacing: "-0.01562em",
				fontSize: "2rem",
			},
			h3: {
				fontWeight: 600,
				lineHeight: 1.167,
				letterSpacing: "-0.01562em",
				fontSize: "1.6rem",
			},
			h4: {
				fontWeight: 600,
				lineHeight: 1.167,
				letterSpacing: "-0.01562em",
				fontSize: "1.3rem",
			},
			h5: {
				fontWeight: 600,
				lineHeight: 1.167,
				letterSpacing: "-0.01562em",
				fontSize: "1rem",
			},
			h6: {
				fontWeight: 600,
				lineHeight: 1.167,
				letterSpacing: "-0.01562em",
				fontSize: "0.8rem",
			},
			body2: {
				lineHeight: "1.5",
				opacity: "0.7",
			},
			button: {
				fontWeight: 600,
			},
		},
		components: {
			MuiCssBaseline: {
				styleOverrides: (themeParam) => `
          @keyframes fadeIn {
            from {
              opacity: 0;
            }
          }
          .loading-pulse {
            animation: fadeIn 0.5s infinite alternate linear;
          }
        `,
			},
			MuiTypography: {
				defaultProps: {
					variantMapping: {
						h1: "h1",
						h2: "h2",
						h3: "h3",
						h4: "h4",
						h5: "h4",
						h6: "h4",
						subtitle1: "h4",
						subtitle2: "h4",
						body1: "p",
						body2: "p",
					},
				},
			},
		},
	};
	config = config ? mergeDeep(defaultConfig, config) : defaultConfig;
	return {
		theme: createTheme(config),
		googleFonts:
			config.googleFonts || "Poppins:ital,wght@0,400;0,600;1,400;1,600",
	};
}

export default getTheme;
